import { Observable } from 'rxjs';

import { MgmtDept } from '../models/mgmt-dept.model';

export abstract class MgmtDeptGateway {
  abstract getMgmtDept(mgmtDeptId: string): Observable<MgmtDept>;
}
